var map = {
	"./Service_NSW.svg": 26442,
	"./additional-learning-support.svg": 38285,
	"./ads-404-icon.svg": 92003,
	"./bg-banner@3x.png": 46897,
	"./brand-left-circle.svg": 43728,
	"./brand-right-shapes.png": 1210,
	"./green_tick.svg": 36533,
	"./icon-assess.svg": 35398,
	"./icon-child-attending.svg": 84675,
	"./icon-circle-cross.svg": 96040,
	"./icon-circle-tick.svg": 65716,
	"./icon-come-back.svg": 23821,
	"./icon-complete-app.svg": 68774,
	"./icon-doc-search.svg": 83847,
	"./icon-edit.svg": 25502,
	"./icon-email.svg": 3328,
	"./icon-generic-error.png": 25902,
	"./icon-info-exchange.svg": 70345,
	"./icon-info.svg": 4369,
	"./icon-local-school.svg": 47008,
	"./icon-magnify-red.svg": 73930,
	"./icon-magnify.svg": 93068,
	"./icon-next-steps.svg": 77439,
	"./icon-no-local-school.svg": 27103,
	"./icon-np-tick.svg": 17233,
	"./icon-out-of-area.svg": 57057,
	"./icon-school-alt.svg": 97294,
	"./icon-school-bck.svg": 27757,
	"./icon-school.svg": 74337,
	"./icon-temporary-residents.svg": 74124,
	"./icon-timeframes.svg": 73886,
	"./icon-timeout.png": 91174,
	"./icon-what-happens.svg": 92393,
	"./icon-whats-online.svg": 65471,
	"./icon-who-not-for.svg": 24453,
	"./icon-will-have-space.svg": 16615,
	"./icon-world-chat.svg": 72606,
	"./logo-colour.svg": 52679,
	"./logo.svg": 69574,
	"./no1.svg": 62839,
	"./no2.svg": 93665,
	"./survey-icon.svg": 31580,
	"./timeline1.svg": 78063,
	"./timeline2.svg": 41061,
	"./timeline3.svg": 66766,
	"./timeline4.svg": 96960,
	"./timeline5.svg": 56915,
	"./whatsnext.svg": 10414
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;